import { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";

import {
  FormInput,
  FormSelector,
  FormRadioButton,
  FormCheckbox,
} from "../FormElements/index";
import { Button } from "../Elements";
import FormObserver from "../FormElements/FormObserver";
import { filtersSchema } from "../../../common/validators/freePaymentSchema";
import InstallmentCheckBoxes from "../InstallmentCheckBoxes";
import { useLoading } from "../../../hooks/useLoading";
import { formatCurrency, formatDate } from "../../../lib/helpers";
import { TbDots } from "react-icons/tb";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import commonNetwork from "../../../common/api/commonNetwork";
import { useDispatch, useSelector } from "react-redux";
import { getExpireDateById, paymentLinkDates } from "../../../constants/options/linkExpireDates";
import { getSendOptionById, sendOptions, sendTypeIds } from "../../../constants/options/sendOptions";
import { controlPaymentLinkPackages } from "../../../common/helpers/packagesHelper";
import PackageErrorModal from "../PackageErrorModal";
import PaymentLinkResultModal from "../PaymentLinkResultModal";
import { getLinkParameters } from "../../../store/slices/linkParametersSlice"
import appHelpers from "../../../common/helpers/appHelpers";
import { getLinkInstallments } from "../../../common/helpers/installmentHelpers";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import useGetCustomerName from "../../../hooks/useGetCustomerName";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import RadioButtons from "../Elements/RadioButtons";
import { ThunkDispatch } from "redux-thunk";
import { OptionModel } from "../../../common/types/OptionModel";
import FormMaskedInput from "../FormElements/FormMaskedInput";
import { refreshLinksTable } from "../../../common/helpers/refreshTables/refreshLinksTable";
import { RootStateType } from "../../../store/RootState";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { getCustomerBalance, paymentHelpers } from "../../../common/helpers/paymentHelpers";
import { FaCopy } from 'react-icons/fa';
import LineLoader from "../LineLoader";
import HtmlTableButton from "../Payment/HtmlTableButton";
import { isBankSelectable } from "../../../common/helpers/isBankSelectable";
import { isCommissionSelectable } from "../../../common/helpers/isCommissionSelectable";
import getCurrencyIsoCodeByCurrencyId from "../../../common/helpers/getCurrencyIsoCodeByCurrencyId";
import { isAuthorizeToFreePayment } from "../../../common/helpers/authorizationHelper";

type FilterType = {
  customername: string,
  customercode: string,
  tcnvkn: string,
  amount: string,
  sendtypeid: any,
  email: string,
  phone: string,
  linkdesc: string,
  paymentType: string,
  vpId: number,
  expiredate: any,
  installments: number[],
  isEditableAmount: boolean,
  isDisableCommission: boolean,
  customer: any,
  currency: string,
  balanceAmount: string,
}

export default function Filters() {
  const url = window.location.href;
  const paymentPage = paymentHelpers.getPaymentPageType(url);

  const isWebPortal = paymentPage == "portal";
  const isPaymentLink = paymentPage == "paymentLink";

  const { defaultSendTypeId, linkExpiryDate } = useSelector((state: any) => state.linkParameters);
  const { parameters } = useSelector((state: any) => state.parameters);

  const { firmInformations } = useRecoilValue(tenantState);

  const initialValues: FilterType = JSON.parse(JSON.stringify({
    customername: "",
    customercode: "",
    tcnvkn: "",
    amount: "",
    sendtypeid: defaultSendTypeId,
    email: "",
    phone: "",
    linkdesc: "",
    paymentType: "dynamic",
    vpId: 0,
    expiredate: linkExpiryDate,
    installments: [1],
    isEditableAmount: false,
    isDisableCommission: false,
    customer: null,
    currency: 1,
    balanceAmount: "",
  }));

  const linResultModalRef: any = useRef();
  const formRef: any = useRef();
  const isFormClearable = useRef(false);

  const currencySelectList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyListForSelect);
  const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);

  const [bankInstallments, setBankInstallments] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [postLinkLoading, setPostLinkLoading] = useState(false);
  const [isPackageErrorModalVisible, setIsPackageErrorModalVisible] = useState(false);
  const [packageErrorMessage, setPackageErrorMessage] = useState("");
  const [vpList, setVpList] = useState<any>([]);
  const [vpDetailsList, setVpDetailsList] = useState([]);
  const [statusModalVisible, setStatusModalVisible] = useState(false);
  const [customerOptions, setCustomerOptions] = useState<OptionModel[]>([]);
  const [formValues, setFormValues] = useState<FilterType>(initialValues);
  const [packageErrorText, setPackageErrorText] = useState<string>("");
  const [balanceMessage, setBalanceMessage] = useState<string>("");
  const [paymentLink, setPaymentLink] = useState<string | any>(null);
  const [loadingCustomer, setLoadingCustomer] = useState<boolean>(false);
  const [linkHash, setLinkHash] = useState<string>("");

  const [fields, setFields] = useState({
    customerRadio: "manuel"
  });

  const loading = useLoading(isFetching);

  const isDemoUser = appHelpers.isDemoUser();

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useLayoutEffect(() => {

    dispatch(getLinkParameters());
    fetchData();
    handleCustomerRadio();
  }, [])

  useEffect(() => {
    if (statusModalVisible != true) {
      clearIfFormClearable();
    }

  }, [statusModalVisible]);

  useGetCustomerName(setCustomerOptions, setLoadingCustomer);

  useEffect(() => {
    onCustomerSelect();
  }, [fields.customerRadio]);

  useEffect(() => {
    if (formValues.customer > 0) {
      fillCustomerFields();
      selectCustomerBalance();
    }
  }, [formValues.customer]);

  const openCustomerForm = () => {
    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromFreePayment
    }
    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  const fetchData = async () => {
    setIsFetching(true);
    const res = await commonNetwork.get("/virtualpos/firmvirtualpos-v1");
    const response = res;
    let vpTemp: any = [];

    setIsFetching(false);
    if (res.isSuccess) {
      response.data.map((vp: any) => {
        if (vp.status) {
          vpTemp.push({
            value: vp.vpid,
            label: vp.vpdisplayname,
          });
        }
      });

      setVpList(vpTemp);

      setVpDetailsList(response.data);
      updateInstallmentListByVP();
    } else {
      toast.error(res.errorMessage);
    }
  };

  const onUpdate = (value: any) => {
    if (!loading) {
      if (value.paymentType === "dynamic") {
        value.vpId = 0;
      } else {
        if (value.vpId === 0 && vpDetailsList.length > 0)
          value.vpId = vpList[0].value;
      }
      setFormValues({ ...formValues, ...value });
    }
  };

  const updateFormInstallments = (month: any) => {
    let temp = formValues.installments;
    if (temp.includes(month)) {
      temp = temp.filter((i) => i !== month);
    } else {
      temp.push(month);
    }
    temp = Array.isArray(temp) ? temp : [temp];
    setFormValues({ ...formValues, installments: temp });
  };

  const updateInstallmentListByVP = () => {
    if (formValues.vpId !== 0) {
      let vpDetail: any = vpDetailsList.find(
        (item: any) => item.vpid === formValues.vpId
      );
      let installmentList = getLinkInstallments(vpDetail.installmentListV1);

      setBankInstallments(installmentList);
    }
  };

  useEffect(() => {
    updateInstallmentListByVP();
  }, [formValues.vpId, vpDetailsList]);

  const onSubmit = async (values: any, actions: any) => {
    var currencyIsoCode = getCurrencyIsoCodeByCurrencyId(currencyList, values.currency);
    let installments = "";
    values.installments.map((installment: any) => {
      if (installments !== "") installments += ",";
      installments += installment;
    });

    var customerName = values.customername;
    if (customerName.length <= 5) {
      customerName = customerName + " test";
    }

    let formObject = {
      INSTALLMENTS: installments,
      CUSTOMERNAME: customerName,
      CUSTOMERCODE: values.customercode,
      TAXCODE: values.tcnvkn,
      AMOUNT: values.amount.replaceAll(",", "").replace(".", ""),
      SENDTYPEID: values.sendtypeid || 3,
      EMAIL: values.email,
      PHONE: values.phone
        ?.replace("(", "")
        .replace(")", "")
        .replace(/\s+/g, ""),
      LINKDESC: values.linkdesc,
      VPID: values.vpId,
      EXPIREDATE: formatDate(new Date()),
      EXPIREDATETYPE: values.expiredate,
      ISEDITAMOUNT: values.isEditableAmount,
      ISCOMMISSION: values.isDisableCommission == true ? false : true,
      CUSTOMERID: values.customer === null ? 0 : values.customer,
      CURRENCYISOCODE: currencyIsoCode
    };

    if (formObject.SENDTYPEID !== sendTypeIds.email && isDemoUser) {
      toast.error("Demo kullanımda sadece E-Mail ile gönderim yapabilirsiniz");
    }
    else {
      controlPackages(formObject, actions);
    }
  }

  const controlPackages = async (formObject: any, actions: any) => {
    var smsCount = 0, emailCount = 0, whatsappCount = 0;
    if (formObject.SENDTYPEID == sendTypeIds.sms) {
      smsCount++;
    } else if (formObject.SENDTYPEID == sendTypeIds.email) {
      emailCount++;
    } else if (formObject.SENDTYPEID == sendTypeIds.whatsapp) {
      whatsappCount++;
    } else {
      emailCount++;
      smsCount++;
    }

    setPostLinkLoading(true);

    const packageResult = await controlPaymentLinkPackages(smsCount, emailCount, whatsappCount);

    if (packageResult.serviceError != true) {

      const { isMailOverflow, isSmsOverflow, mailOverflowCount, smsOverflowCount, isWhatsappOverflow } = packageResult;

      if ((formValues.sendtypeid == 1 || formValues.sendtypeid == 3) && isMailOverflow) {
        setPackageErrorText("Email");
        setPostLinkLoading(false);
        setIsPackageErrorModalVisible(true);
      } else if ((formValues.sendtypeid == 2 || formValues.sendtypeid == 3) && isSmsOverflow) {
        setPackageErrorText("SMS");
        setPostLinkLoading(false);
        setIsPackageErrorModalVisible(true);
      } else if ((formValues.sendtypeid == 5) && isWhatsappOverflow) {
        setPackageErrorText("Whatsapp");
        setPostLinkLoading(false);
        setIsPackageErrorModalVisible(true);
      } else {
        postPaymentLinksAfterControl(formObject, actions);
      }

      // if (isMailOverflow || isSmsOverflow || isWhatsappOverflow) {
      //   setPostLinkLoading(false);
      //   setIsPackageErrorModalVisible(true);
      // } else {
      //   postPaymentLinksAfterControl(formObject, actions);
      // }
    } else {
      setPostLinkLoading(false);
      toast.error(packageResult.errorMessage);
    }
  }

  const postPaymentLinksAfterControl = async (formObject: any, actions: any) => {
    const response = await commonNetwork.post("/payment-link", formObject);
    setPostLinkLoading(false);

    var successList = [], errorList = [];

    const element = response.data;
    if (response.isSuccess == false) {
      toast.error(response.errorMessage);
    } else {
      if ((!element.smsstatus || !element.mailstatus)) {
        errorList.push({
          ...element,
        });
      } else {
        if (formValues.sendtypeid == 4) {
          setPaymentLink(element.link);
        } else {
          setPaymentLink(null);
        }
        refreshLinksTable(dispatch);
        successList.push({
          ...element
        });
      }
      setLinkHash(element.hash);

      setStatusModalVisible(true);

      if (errorList.length == 0) {
        isFormClearable.current = true;
      }

      linResultModalRef.current.showMessage(errorList, successList);
    }
  }

  function clearIfFormClearable() {
    if (isFormClearable.current) {
      isFormClearable.current = false;
      setTimeout(() => {
        clearFilters();
      }, 100);
    }
  }

  const clearFilters = () => {
    formRef.current.resetForm()
    setFormValues(initialValues);
  };

  function onCustomerSelect() {
    setFormValues(prevValues => ({
      ...prevValues,
      customer: null,
      customercode: "",
      customername: "",
      tcnvkn: "",
      email: "",
      phone: ""
    }));
  }

  const fillCustomerFields = async () => {
    let result = await commonNetwork.get("/customer/" + formValues.customer);

    if (result.isSuccess) {
      const data = result.data;

      const email: string = data.email ?? "";
      const tcCode: string = data.tcCode ?? "";

      setFormValues(prevValues => ({
        ...prevValues,
        customercode: data.customerCode,
        customername: data.customerName,
        tcnvkn: tcCode.length > 10 ? tcCode : data.taxCode,
        email: email.split(";")[0],
        phone: data.phone != null && data.phone != "" ? data.phone.startsWith("0") ? data.phone.substring(1) : data.phone : "",
      }));
    } else {
      setFormValues(prevValues => ({
        ...prevValues,
        customercode: "",
        customername: "",
        tcnvkn: "",
        email: "",
        phone: "",
        customer: null
      }));
      toast.error(result.errorMessage);
    }
  }

  const onChangeCustomerRadio = (event: any) => {
    setFields({
      customerRadio: event.target.value
    });
  }

  const handleCustomerRadio = () => {
    if (isAuthorizeToFreePayment() == false) {
      setFields({
        customerRadio: "select"
      });
    }
  }

  const selectCustomerBalance = async () => {
    setPostLinkLoading(true);
    const balance = await getCustomerBalance(formValues.customer);

    if (balance.isSuccess) {
      const formattedBalance = formatCurrency(balance.data);
      setFormValues(prevValues => ({ ...prevValues, balanceAmount: formattedBalance || "0" }));
      setBalanceMessage("");
    } else {
      setBalanceMessage(balance.data);
    }

    setPostLinkLoading(false);
  }

  const copyPaymentLink = () => {
    navigator.clipboard.writeText(paymentLink)
    toast.success("Link başarılı bir şekilde kopyalandı");
  }

  return (
    <Formik
      initialValues={formValues}
      validationSchema={filtersSchema}
      enableReinitialize
      onSubmit={onSubmit}
      innerRef={formRef}
    >
      {formProps => (
        <Form>
          <FormObserver watch={(val: any) => onUpdate(val)} />
          <div className="mx-4 px-4 py-2  bg-white shadow-md mb-4 pb-4 mt-1 rounded-md">
            <div className="px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4">
              <div className="mt-3">
                <h1 className="font-bold text-contrast-90">Müşteri Bilgileri</h1>
                <span className="text-contrast-50 text-md">
                  Alıcı cari hesap bilgileri ve tutar bilgisini yazınız
                </span>
              </div>

              <div className="w-full col-span-2">
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2  ">
                  <div className="mt-8">
                    <RadioButtons
                      items={[
                        { label: "Elle Doldur", value: "manuel", disabled: !isAuthorizeToFreePayment() },
                        { label: "Müşteri Seç", value: "select", disabled: false },
                      ]}
                      onValueChange={onChangeCustomerRadio}
                      checked={fields.customerRadio}
                    />
                  </div>
                  <div className={fields.customerRadio === "manuel" ? "hidden" : "mt-3"}>
                    <FormSelector
                      options={customerOptions}
                      name="customer"
                      placeholder="Müşteri Seç"
                      label="Müşteri Seç"
                      value={getSelectedValueFromId(formProps.values.customer, customerOptions)}
                      isSearchable
                      isClearable
                      isLazyFrontend
                      lazyPageSize={50}
                      loading={loadingCustomer}
                      isDisabled={isFetching}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2  ">
                  <div className="mt-3">
                    <FormInput
                      // disabled={fields.customerRadio === "select" ? true : false}
                      label="Cari Hesap Kodu"
                      name="customercode"
                      type="text"
                      maxLength={51}
                      value={formProps.values.customercode}
                      rightIcon={isLogoAppProject() &&
                        <TbDots
                          onClick={openCustomerForm}
                          className="sm:block h-6 w-6 text-black hidden cursor-pointer "
                          aria-hidden="true"
                          color="#0090FF"
                        />
                      }

                    />
                  </div>
                  <div className="mt-3">
                    <FormInput
                      label="Alıcı Ünvan/Adı Soyadı"
                      name="customername"
                      type="text"
                      maxLength={151}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                  <div className={"mt-3"}>
                    <FormMaskedInput
                      label="Alıcı VKN/TCKN*"
                      name="tcnvkn"
                      maskOptions={{
                        blocks: [11],
                        numericOnly: true
                      }}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                  {firmInformations.isCurrency === true ?
                    <div className={"mt-3"}>
                      <FormSelector
                        options={currencySelectList}
                        name="currency"
                        placeholder="Seçiniz"
                        label="Para Birimi*"
                        value={getSelectedValueFromId(formProps.values.currency, currencySelectList)}
                        defaultValue={getSelectedValueFromId(formProps.values.currency, currencySelectList)}
                      />
                    </div> : null}
                  <div className="mt-3">
                    {/* <FormMaskedInput
                      label="Tutar*"
                      name="amount"
                      placeholder="0.00"
                      maskOptions={{
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',  // Binlik ayraç stili
                        numeralDecimalMark: '.',    // Ondalık ayraç
                        delimiter: ',',             // Binlik ayraç sembolü
                        numeralDecimalScale: 2,
                        delimiterLazyShow: true

                      }}
                    /> */}
                    <FormInput
                      label="Tutar*"
                      name="amount"
                      currencyformat="true"
                      currencyicon="true"
                      defaultValue=""
                      value={formProps.values.amount}
                      placeholder="0.00"
                      maxLength={14}
                      currencyId={formProps.values.currency}
                      isTRCurrencyDisplay={true}
                    />
                    {
                      (formValues.customer && firmInformations.isCustomerBalance) ? (
                        <div className="mt-3 flex flex-row items-center">
                          <label className="block decoration-black font-bold whitespace-nowrap cursor-default mr-2">
                            Borç Bakiyesi:
                          </label>
                          {postLinkLoading ? (
                            <LineLoader />
                          ) : (
                            balanceMessage !== "" ? (
                              <p className="text-red-500">{balanceMessage}</p>
                            ) : (
                              <span className="bg-green-200 px-1 decoration-black font-bold">{formValues.balanceAmount} ₺</span>
                            )
                          )}
                        </div>
                      ) : (null)
                    }
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className=" px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4 ">
              <div className="mt-3">
                <h1 className="font-bold text-contrast-90">Gönderim Bilgileri</h1>
                <span className="text-contrast-50 text-md">
                  Gönderim ayarlarınızı ilgili alanları doldurarak belirleyiniz. Ödeme açıklaması zorunlu değildir.
                </span>
              </div>
              <div className="w-full col-span-2">
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                  <div className="mt-3">
                    <FormSelector
                      options={sendOptions.filter(option => option.value !== 0)}
                      name="sendtypeid"
                      placeholder="Seçiniz"
                      label="Gönderim Şekli*"
                      value={getSendOptionById((formProps.values.sendtypeid || 3))}
                      defaultValue={getSendOptionById(defaultSendTypeId || 3)}
                    />
                  </div>
                  <div className="mt-3">
                    <FormMaskedInput
                      label="Telefon*"
                      name="phone"
                      maskOptions={{
                        delimiter: ' ',
                        blocks: [3, 3, 2, 2],
                        numericOnly: true
                      }}
                      placeholder="5xx xxx xx xx"
                    />
                  </div>

                </div>
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">

                  <div className="mt-3">
                    <FormInput
                      label="E-Posta Adresi*"
                      name="email"
                      type="text"
                      maxLength={101}
                    />
                  </div>
                  <div className="mt-3">
                    <FormSelector
                      options={paymentLinkDates}
                      name="expiredate"
                      placeholder="Link Geçerlilik Süresi"
                      defaultValue={getExpireDateById(linkExpiryDate)}
                      label="Geçerlilik Süresi"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                  <div className="mt-3">
                    <FormInput
                      className={"max-h-[70px] min-h-[32px]"}
                      label="Açıklama"
                      name="linkdesc"
                      type="textarea"
                      maxLength={101}
                    />
                  </div>

                  <div className=" mt-10 flex flex-row">
                    <FormCheckbox
                      label={"Tutar Düzenlenebilsin mi?"}
                      name="isEditableAmount"
                      type="checkbox"
                      id="isEditableAmount"
                      onChange={formProps.setFieldValue}
                    />

                    {isCommissionSelectable() &&
                      <FormCheckbox
                        label={"Komisyon Uygulanmasın"}
                        name="isDisableCommission"
                        type="checkbox"
                        id="isDisableCommission"
                        className={"ml-4"}
                        onChange={formProps.setFieldValue}
                      />}
                  </div>
                </div>

                {((isWebPortal || isPaymentLink) && (formValues.currency || 1) == 1 && parameters?.isShowInstallment) && !((formValues.vpId || 0) > 0) && (
                  <HtmlTableButton licenseKey={firmInformations.licenseKey} paymentAmount={formValues.amount} taxCode={firmInformations.taxCode} />
                )}

              </div>
            </div>
            <hr />
            {isBankSelectable() &&
              <div className=" px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-3">
                <div className="mt-3">
                  <h1 className="font-bold text-contrast-90">
                    Ödeme Altyapısı
                  </h1>
                  <span className="text-contrast-50 text-md">
                    Yapılacak ödemeye ait banka ve taksitleri seçiniz
                  </span>
                </div>
                <div className="col-span-2 ">
                  <div className="grid grid-cols-1 gap-2 sm:gap-4 lg:grid-cols-2 xl:grid-cols-2   ">
                    <div className=" mt-10 ">
                      <div className=" items-center flex flex-row">
                        <FormRadioButton
                          items={[
                            { label: "Banka Seç", value: "manuel" },
                            { label: "Dinamik Yönlendirme", value: "dynamic" },
                          ]}
                          checked={formValues.paymentType}
                          name="paymentType"
                        />
                      </div>
                    </div>
                    <div className="mt-3 ">
                      {formValues.paymentType === "manuel" ? (
                        isFetching ? (
                          <div className="mt-4">Yükleniyor...</div>
                        ) : vpList.length > 0 ? (
                          <FormSelector
                            options={vpList}
                            name="vpId"
                            defaultValue={vpList[0]}
                            label="Ödeme Altyapisi"
                            placement="auto"
                          />
                        ) : (
                          <span className="text-base text-error">
                            Aktif sanal POS listeniz veritabanindan okunamamistir.
                            Yetkili ile iletisime geciniz.
                          </span>
                        )
                      ) : isFetching ? (
                        <div className="mt-4">Yükleniyor...</div>
                      ) : vpList.length > 0 ? (
                        <div className=" mt-6 ">
                          <span className="text-base text-contrast-70">
                            *Kredi kartına göre ilgili ödeme kuruluşuna otomatik yönlendirilir.
                          </span>
                        </div>
                      ) : (
                        <span className="text-base text-error">
                          Aktif sanal POS listeniz veritabanindan okunamamistir.
                          Yetkili ile iletisime geciniz.
                        </span>
                      )}
                    </div>
                  </div>
                  {formValues.paymentType === "manuel" && vpList.length > 0 && (
                    <div className="col-span-2">
                      <InstallmentCheckBoxes
                        className="mt-3 grid grid-cols-2 gap-2 sm:gap-2 lg:grid-cols-3 xl:grid-cols-3"
                        installments={bankInstallments}
                        checkedlist={formValues.installments}
                        callback={(val: any) => {
                          updateFormInstallments(val);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            }
            {paymentLink != null ?
              <>
                <hr />
                <div className="px-4 grid grid-cols-1 lg:grid-cols-3 gap-2 sm:gap-3 mb-4">
                  <div className="mt-3 lg:col-span-1">
                    <h1 className="font-bold text-contrast-90">Ödeme Linki</h1>
                    <span className="text-contrast-50 text-md">
                      Oluşturmuş olduğunuz linke tıklayarak ödeme ekranına gidebilirsiniz. Ya da butona tıklayarak linki kopyalayabilirsiniz.
                    </span>
                  </div>

                  <div className="mt-8 lg:col-span-2">
                    <div className='flex'>
                      <FaCopy className="mr-2 mt-1 cursor-pointer text-[#729aa5]" onClick={copyPaymentLink} />
                      <a className='text-sky-700' href={paymentLink} target='_blank'>
                        {paymentLink}
                      </a>
                    </div>
                  </div>
                </div>

              </> :
              ""
            }
            <div className="mt-3 justify-end mr-3 flex flex-row">
              <Button
                type="reset"
                color="gray"
                hover="gray"
                size="xs"
                className="mr-3"
                callback={() => {
                  clearFilters()
                }}
              >
                Tüm Alanları Temizle
              </Button>
              <Button
                type="submit"
                color="primary"
                hover="primary"
                size="xs"
                disabled={vpList.length < 1 ? true : (postLinkLoading)}
                loading={postLinkLoading}
              >
                {formValues.sendtypeid == 4 ? "Oluştur" : "Gönder"}
              </Button>
            </div>
          </div>

          {/* {getModalHtml()} */}

          <PackageErrorModal errorMessage={packageErrorMessage} isVisible={isPackageErrorModalVisible} setIsVisible={setIsPackageErrorModalVisible} packageErrorText={packageErrorText}></PackageErrorModal>

          <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible} sendTypeId={formValues.sendtypeid} linkHash={linkHash} />
        </Form>
      )}
    </Formik>
  );
}